import { Tables } from "../../supabase/supabaseTypesImport";

type Channel = Tables<"message_channels">;

export const countUnreadChannelsByClientId = (
	channels: Channel[],
	connectedOrgIdToClientId: Record<string, string>,
	myOrgId: string
): Record<string, number> => {
	const counts: Record<string, number> = {};
	for (const channel of channels) {
		if (channel.vendor_org_id !== myOrgId || (channel.unread_count || 0) <= 0) continue;

		const clientId = channel.job_client_id
			?? (channel.customer_org_id ? connectedOrgIdToClientId[channel.customer_org_id] : undefined);

		if (clientId) {
			counts[clientId] = (counts[clientId] || 0) + 1;
		}
	}
	return counts;
};
